import React, { forwardRef, useImperativeHandle, useState, useCallback } from "react";
import { Toast, ToastBody, ToastHeader } from "reactstrap";
import { toastRef } from "./toast";

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ show: false, message: "", type: "info" });

  const showToast = useCallback((type, message) => {
    setToast({ show: true, type, message });
    setTimeout(() => setToast({ show: false, message: "", type }), 3000);
  }, []);

  useImperativeHandle(toastRef, () => ({ showToast }));

  const bgColor =
    toast.type === "success" ? "bg-success" :
    toast.type === "error" ? "bg-danger" :
    "bg-info";

  return (
    <>
      {children}
      <div
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 2000,
          minWidth: "250px"
        }}
      >
        <Toast isOpen={toast.show}>
          <ToastHeader className={`${bgColor} text-white`}>
            {toast.type === "success"
              ? "Success"
              : toast.type === "error"
              ? "Error"
              : "Info"}
          </ToastHeader>
          <ToastBody>{toast.message}</ToastBody>
        </Toast>
      </div>
    </>
  );
};
